import React from "react";
import { Box, Skeleton } from "@mui/material";

export default function CategorySkeleton() {
  return (
    <Skeleton
      variant="rounded"
      sx={{
        width: "100%",
        height: "auto",
        aspectRatio: { xs: "1 / 0.95", sm: "1 / 0.85", md: "1 / 0.72" },
        borderRadius: "18px",
      }}
    />
  );
}
